import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { setMeta } from '../utils/seo';

function Download() {
  const currentDomain = process.env.REACT_APP_WEBSITE_DOMAIN || window.location.hostname;
  const cleanDomain = currentDomain.replace(/^www\./, '');
  const crossDomainBridgeMap = {
    'fishpt.com': [
      { href: 'https://zjfhzs.cn/download', label: '新手下载入口（zjfhzs.cn）' },
      { href: 'https://donghaiedu.com/download', label: '备用下载入口（donghaiedu.com）' }
    ],
    'lgysjpj.com': [
      { href: 'https://ggxhu.com/download', label: '官方下载入口（ggxhu.com）' },
      { href: 'https://jshstx.com/download', label: '低延迟下载页（jshstx.com）' }
    ],
    'ruxinkeji.com': [
      { href: 'https://donghaiedu.com/hhpoker-latest-download', label: '最新版本专题（donghaiedu.com）' },
      { href: 'https://zjfhzs.cn/install-guide', label: '安装指引页（zjfhzs.cn）' }
    ]
  };
  const crossDomainBridgeLinks = crossDomainBridgeMap[cleanDomain] || [];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
    setMeta({
      title: 'HHpoker下载｜官方最新版安卓与iOS下载入口',
      description: '提供HHpoker官方最新版下载入口，含安卓与iOS安装步骤、下载失败排查、版本更新说明及安全下载建议，快速完成安装。',
      keywords: 'HHpoker下载, HHpoker官方下载, HHpoker最新下载, HHpoker iOS下载, HHpoker安卓版下载, 德扑圈APP下载',
      url: window.location.origin + '/download/',
      robots: 'index,follow',
      image: window.location.origin + '/images/banner.jpg',
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "hhpoker下载入口有几个？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "建议只使用本页官方下载入口，避免使用来源不明的旧链接。"
            }
          },
          {
            "@type": "Question",
            "name": "hhpoker最新下载怎么判断是否为新版本？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "以本页更新时间和版本说明为准，优先下载最近维护版本。"
            }
          },
          {
            "@type": "Question",
            "name": "iOS 和安卓下载包可以通用吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "不通用，需按设备系统分别下载对应安装包。"
            }
          },
          {
            "@type": "Question",
            "name": "下载完成后安装失败怎么办？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "先检查包体完整性，再按安装教程完成证书或权限设置。"
            }
          },
          {
            "@type": "Question",
            "name": "旧版本需要先卸载吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "如出现冲突、闪退或无法启动，建议先卸载旧版再安装最新版。"
            }
          }
        ]
      }
    });
  }, []);

  const handleDownloadClick = (e) => {
    e && e.preventDefault && e.preventDefault();
    const event = new CustomEvent('openContactModal');
    window.dispatchEvent(event);
  };

  

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      
      

      {/* Hero / Download Section */}
      <section className="hero-section download-hero"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(rgba(20,22,34,0.8), rgba(20,22,34,0.95)), url('/images/banner.jpg') center/cover no-repeat fixed`,
          padding: '100px 8vw',
          textAlign: 'center'
        }}
      >
        <div data-aos="fade-down" style={{ marginBottom: '40px' }}>
           <h1 style={{
            fontSize: '3.5rem',
            color: '#efa765',
            fontWeight: 800,
            marginBottom: '24px',
            textShadow: '0 4px 20px rgba(0,0,0,0.5)'
          }}>HHpoker 最新下载 iOS/安卓版/手机版APP</h1>
          <p style={{
            fontSize: '1.2rem',
            color: '#e0e0e0',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: 1.6
          }}>
            这里是 HHpoker官方网站下载入口，支持 <span style={{color:'#efa765',fontWeight:'bold'}}>iOS 15.0+</span> 与 <span style={{color:'#efa765',fontWeight:'bold'}}>Android 8.1+</span>。
          </p>
        </div>

        <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '60px' }}>
          <div onClick={handleDownloadClick} className="btn-ios" data-aos="zoom-in" data-aos-delay="100" style={{
            display: 'flex',
            alignItems: 'center',
            background: 'transparent',
            border: '2px solid #efa765',
            color: '#efa765',
            padding: '16px 46px',
            borderRadius: '50px',
            fontSize: '1.2rem',
            fontWeight: 700,
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            userSelect: 'none'
          }}
          onMouseOver={(e) => {
             e.currentTarget.style.background = '#efa765';
             e.currentTarget.style.color = '#1a1c29';
             e.currentTarget.style.boxShadow = '0 0 20px rgba(239,167,101,0.4)';
          }}
          onMouseOut={(e) => {
             e.currentTarget.style.background = 'transparent';
             e.currentTarget.style.color = '#efa765';
             e.currentTarget.style.boxShadow = 'none';
          }}
          >
            <span style={{ fontSize: '1.5rem', marginRight: '10px', display: 'flex', alignItems: 'center' }}>
             <img src="/images/apple.png" alt="iOS" style={{ width: '30px', height: 'auto' }} />
            </span> 获取 iOS 下载链接
          </div>

          <div onClick={handleDownloadClick} className="btn-android" data-aos="zoom-in" data-aos-delay="200" style={{
            display: 'flex',
            alignItems: 'center',
            background: 'transparent',
            border: '2px solid #efa765',
            color: '#efa765',
            padding: '16px 46px',
            borderRadius: '50px',
            fontSize: '1.2rem',
            fontWeight: 700,
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            userSelect: 'none'
          }}
          onMouseOver={(e) => {
             e.currentTarget.style.background = '#efa765';
             e.currentTarget.style.color = '#1a1c29';
             e.currentTarget.style.boxShadow = '0 0 20px rgba(239,167,101,0.4)';
          }}
          onMouseOut={(e) => {
             e.currentTarget.style.background = 'transparent';
             e.currentTarget.style.color = '#efa765';
             e.currentTarget.style.boxShadow = 'none';
          }}
          >
            <span style={{ fontSize: '1.5rem', marginRight: '10px', display: 'flex', alignItems: 'center' }}>
               <img src="/images/andiro.png" alt="Android" style={{ width: '30px', height: 'auto' }} />
            </span> 获取 Android 下载链接
          </div>
        </div>

        <p data-aos="fade-up" data-aos-delay="300" style={{
          fontSize: '0.9rem',
          color: '#888',
          maxWidth: '500px',
          margin: '0 auto',
          lineHeight: '1.5'
        }}>
          * 为保障账号安全，请通过上方按钮联系官方客服获取最新版安装包与安装指引。
        </p>
      </section>

      <section style={{ padding: '40px 8vw', background: '#1f2233' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ color: '#efa765', fontSize: '1.6rem', marginBottom: '12px' }}>HHpoker下载常见问题</h2>
          <p style={{ color: '#cfd3dc' }}>
            若你正在搜索 HHpoker 下载、HHpoker 最新下载 iOS、HHpoker 安卓版下载或 HHpoker 手机版 APP，建议优先使用官方入口获取最新版本，
            避免旧包导致安装失败或闪退。
          </p>
          <ul style={{ color: '#cfd3dc', paddingLeft: '20px', marginTop: '12px' }}>
            <li>iOS 设备：安装后需完成证书信任步骤。</li>
            <li>Android 设备：首次安装需允许未知来源安装权限。</li>
            <li>旧版本用户：建议先卸载旧包再安装最新版。</li>
          </ul>
          <div style={{ marginTop: '14px' }}>
            <Link to="/install-guide" style={{ color: '#efa765', textDecoration: 'underline' }}>
              查看：HHpoker苹果iOS信任证书教程与安卓安装指引
            </Link>
          </div>
          <div style={{ marginTop: '18px' }}>
            <h3 style={{ color: '#efa765', fontSize: '1.2rem', marginBottom: '8px' }}>下载入口快速问答</h3>
            <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker下载入口有几个？</strong></p>
            <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：建议只使用本页官方下载入口，避免使用来源不明的旧链接。</p>
            <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker最新下载怎么判断是否为新版本？</strong></p>
            <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：以本页更新时间和版本说明为准，优先下载最近维护版本。</p>
            <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：iOS 和安卓下载包可以通用吗？</strong></p>
            <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：不通用，需按设备系统分别下载对应安装包。</p>
            <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：下载完成后安装失败怎么办？</strong></p>
            <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：先检查包体完整性，再按安装教程完成证书或权限设置。</p>
            <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：旧版本需要先卸载吗？</strong></p>
            <p style={{ color: '#aeb4c2', marginBottom: '0' }}>A：如出现冲突、闪退或无法启动，建议先卸载旧版再安装最新版。</p>
          </div>
        </div>
      </section>

      {crossDomainBridgeLinks.length > 0 && (
        <section style={{ padding: '24px 8vw', background: '#171a28', borderTop: '1px solid #2a2d42' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h2 style={{ color: '#efa765', fontSize: '1.2rem', marginBottom: '10px' }}>跨站入口推荐</h2>
            <p style={{ color: '#b8bfce', marginTop: 0, marginBottom: '10px', fontSize: '0.92rem' }}>
              下列站点页为同主题可抓取入口，用于加强跨站发现与收录稳定性。
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px', color: '#cfd3dc', lineHeight: 1.9 }}>
              {crossDomainBridgeLinks.map((item) => (
                <li key={item.href}>
                  <a href={item.href} style={{ color: '#efa765', textDecoration: 'none' }}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}

      {/* Footer Section - Simplified */}
      <footer style={{ background: '#0c0909', padding: '40px 8vw', borderTop: '1px solid #222', textAlign: 'center' }}>
        <p style={{ color: '#555', fontSize: '0.9rem' }}>Copyright © 2026 HHpoker. All Rights Reserved.</p>
      </footer>

    </div>
  );
}

export default Download;
